import { useInternet } from "../../../../../hooks/useInternet.js";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as zod from "zod";
import { SimpleField } from "../../../../../components/fields/simpleField.jsx";
import { Button } from "../../../../../components/button.jsx";

export function HelpPage() {
  let internet = useInternet();
  let [messageSent, setMessageSent] = useState(false);
  let { control, handleSubmit } = useForm({
    resolver: zodResolver(zod.object({ message: zod.string() })),
  });
  let contact = handleSubmit((d) =>
    internet.post("/help", d).then(() => setMessageSent(true))
  );
  return (
    <div className={"flex flex-col gap-3 p-3"}>
      {" "}
      <div className={"flex"}>
        <h2 className={"font-bold py-2 flex items-center flex-grow"}>Help</h2>
      </div>
      <div className={"flex flex-col gap-3"} style={{ maxWidth: 500 }}>
        {" "}
        <p>
          Do you have any question about our product, and how to use it? Feel
          free to contact us
        </p>
        {messageSent ? (
          <div className={"bg-green-100 p-3 rounded flex flex-col gap-3"}>
            <div>
              Thank you for your message. Our team will get back to you as soon
              as possible.
            </div>

            <div>
              or{" "}
              <a
                href={"#"}
                onClick={() => setMessageSent(false)}
                className={"hover:underline"}
              >
                ask another question
              </a>
            </div>
          </div>
        ) : (
          <div>
            <form onSubmit={contact} className={"flex flex-col gap-3"}>
              <SimpleField
                control={control}
                type={"textarea"}
                name={"message"}
                label={"Your message"}
              />
              <Button onClick={contact} type={"submit"}>
                Contact us
              </Button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
